<template>
    <div data-component="stratmk.mobi-footer.v12020" class="mobi-footer">
        <div class="text-center">
            <span class="text-uppercase font-weight-light">
                <span class="font-weight-black white--text" style="font-size: 14px">Strategery.</span>
            </span>
        </div>
        <div class="text-center mt-n2">
            <span class="t10 roboto ls4 grey--text">
                Better Tools. Better Results.
            </span>
        </div>
        <div class="text-center mt-4 t10 grey--text">
            <span class="mx-3" @click="openTc()">Terms & Conditions</span>
            <span class="mx-3" @click="openPp()">Privacy Policy</span>
        </div>
        <div class="grey--text text-center t10 mt-2">
            © {{cry}} DoloLabs LLC. All Rights Reserved.
        </div>
        <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="pp">
            <v-card class="pa-6">
            <privacy-policy @closePp="closePp()"/>
            </v-card>
        </v-dialog>
        <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="tc">
            <v-card class="pa-6">
                <terms @closeTc="closeTc()"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import privacyPolicy from '../views/privacy-policy'
import terms from '../views/terms'

export default {
    components: {
        privacyPolicy,
        terms,
    },
    props: {},
    data: () => {
        return {
            cry: 2020,
            pp: false,
            tc: false,
        }
    },
     methods: {
        openPp(){
            this.pp = true
        },
        openTc(){
            this.tc = true
        },
        closePp(){
            this.pp = false
        },
        closeTc(){
            this.tc = false
        },
    }
}
</script>

<style lang="scss" scoped>

    $hover-color: #2BCDC9;

    .mobi-footer {
        margin-top: 36%
    }
</style>